const sectionIds = [
  "booking-location",
  "booking-service",
  "booking-calendar",
  "booking-confirm-info",
  "booking-confirmation",
];
const actions = {
  "booking-location": loadLocation,
  "booking-service": loadService,
  "booking-calendar": loadCalendar,
  "booking-confirm-info": loadConfirmInfo,
  "booking-confirmation": loadConfirmation,
};
const freeConsultationServiceIdArray = [
  "16bc605b-cfb8-4a66-a5ec-b2a40150067f", // Free Consultation
  "c823edee-5797-478d-aaed-b32200ced55e", // Free Consultation
  "0d0dbb8f-51a3-4276-8a59-b32200cf3d53", // Free Consultation
];
const isMaintenanceServiceIdArray = [
  "b2e08a0d-1e45-4584-b32c-b33e00e25717", // IPL
  "dcbac8ad-2fe0-4d6e-8bfd-b33e00e1b401", // Laser Genesis
  "3adbe1c0-ee65-4aa6-bfd9-b33e00e30b78", // Morpheus8
  "281f8ce1-a5e5-49c3-b62f-b33e00e362d4", // PRP
  "1f2f8fd3-25c3-433f-8abe-b33e00e409ea", // PRP & Sculptra
  "f21f124c-2a5f-4551-adc8-b33e00e3c1ed", // Sculptra
];

const serviceIds = [
  {
    id: "ac8638d8-9a93-4b09-afa6-b305010d9dc6",
    name: "Bra Fat",
    bookingFee: 250,
  },
  {
    id: "16bc605b-cfb8-4a66-a5ec-b2a40150067f",
    name: "Free Consultation",
    bookingFee: 50,
  },
  {
    id: "c823edee-5797-478d-aaed-b32200ced55e",
    name: "Free Consultation_In Person",
    bookingFee: 50,
  },
  {
    id: "0d0dbb8f-51a3-4276-8a59-b32200cf3d53",
    name: "Free Consultation_Virtual",
    bookingFee: 50,
  },
  { id: "b2e08a0d-1e45-4584-b32c-b33e00e25717", name: "IPL", bookingFee: 50 },
  {
    id: "b2e08a0d-1e45-4584-b32c-b33e00e25717",
    name: "Maintenance Session_IPL",
    bookingFee: 50,
  },
  {
    id: "dcbac8ad-2fe0-4d6e-8bfd-b33e00e1b401",
    name: "Maintenance Session_Laser Genesis",
    bookingFee: 50,
  },
  {
    id: "3adbe1c0-ee65-4aa6-bfd9-b33e00e30b78",
    name: "Maintenance Session_Morpheus8",
    bookingFee: 250,
  },
  {
    id: "281f8ce1-a5e5-49c3-b62f-b33e00e362d4",
    name: "Maintenance Session_PRP",
    bookingFee: 250,
  },
  {
    id: "1f2f8fd3-25c3-433f-8abe-b33e00e409ea",
    name: "Maintenance Session_PRP & Sculptra",
    bookingFee: 250,
  },
  {
    id: "f21f124c-2a5f-4551-adc8-b33e00e3c1ed",
    name: "Maintenance Session_Sculptra",
    bookingFee: 250,
  },
  {
    id: "ebcf02d4-a36f-43a2-8613-b2a40150067f",
    name: "Non-Surgical Breast Enhancement™",
    bookingFee: 250,
  },
  {
    id: "89baa8e9-eebc-4869-94af-b305010bd29a",
    name: "Non-surgical Breast Lift™",
    bookingFee: 250,
  },
  { id: "35149a19-b50f-420f-8a65-b2a40150067f", name: "PRP", bookingFee: 250 },
  {
    id: "e7b112a5-4d05-4003-890c-b2a40150067f",
    name: "Scar Revision",
    bookingFee: 250,
  },
];

let currentStep;
let loadedServices = false;
let selectedCalendarDate = null;
let selectedServiceId = null;
let servicesList = [];
let employeeList = [
  {
    name: "Jess",
    id: "9d0f8402-b5b9-4bda-b926-b2a4015006cc",
    imageURL: "",
    openings: [],
    fullName: "Jess C.",
    title: "Breast Aesthetic Provider",
  },
  {
    name: "Noelle",
    id: "0636ab92-65bc-479a-af4f-b2a4015006cc",
    imageURL: "",
    openings: [],
    fullName: "Noelle V.",
    title: "Breast Aesthetic Provider",
  },
  {
    name: "Brianna",
    id: "12516dae-a59e-4e72-a065-b2a4015006cc",
    imageURL: "",
    openings: [],
    fullName: "Brianna T.",
    title: "Breast Aesthetic Specialist",
  },
];
let allowedEmployees = [];
let bookingDataSent = false;
let niceselectDesiredTime;
let niceSelectProvider;
let matchingOpening;
let serviceOpenings = [];
let appointmentCancelled = false;
let modifyFlow = false;

document.addEventListener("click", (e) => {
  const button = e.target.closest("[data-step]");
  if (!button) return;

  const direction = button.getAttribute("data-step");

  // add validation
  const validated = validateStep();

  if (direction === "next") {
    if (currentStep === 3 && bookingDataSent === false && validated) {
      validateAndBook();
    } else if (validated) {
      setStep(currentStep + 1);
      updateNextButtonState();
    }
  } else if (direction === "prev") {
    setStep(currentStep - 1);
  }
});

const validateStep = () => {
  let passValidation = false;
  if (currentStep === 1) {
    // service
    const serviceId = window.localStorage.getItem("serviceId");

    if (serviceId) {
      passValidation = true;
    }
  } else if (currentStep === 2) {
    // date&time
    const bookingTime = window.localStorage.getItem("bookingTime");

    if (bookingTime) {
      passValidation = true;
    }
  } else if (currentStep === 3) {
    // confirmInfo
    const firstNameInput = document.getElementById("RegisterForm-FirstName");
    const lastNameInput = document.getElementById("RegisterForm-LastName");
    const clientEmailInput = document.getElementById("RegisterForm-email");
    const clientPhoneInput = document.getElementById("RegisterForm-phone");
    const paymentTermsCheckbox = document.getElementById(
      "payment-terms_checkbox"
    );
    const cardholderNameInput = document.getElementById("cardholder-name");
    const avsZipInput = document.getElementById("avs-zip");

    const firstNameInputEmpty = firstNameInput.value ? false : true;
    const lastNameInputEmpty = lastNameInput.value ? false : true;
    const emailInputEmpty = clientEmailInput.value ? false : true;
    const phoneInputEmpty = clientPhoneInput.value ? false : true;
    const paymentTermsUnchecked = paymentTermsCheckbox.checked ? false : true;
    const cardholderNameEmpty = cardholderNameInput.value ? false : true;
    const avsZipEmpty = avsZipInput.value ? false : true;

    // Nested function to validate email
    const validateEmail = (email) => {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    };

    const validatePhoneNumber = (phone) => {
      // Strip only spaces, hyphens, and parentheses
      const strippedPhone = phone.replace(/[\s\-\(\)]/g, "");
      // Check if the stripped number is exactly 10 digits
      return /^\d{10}$/.test(strippedPhone);
    };

    const emailValidated = validateEmail(clientEmailInput.value);
    const phoneNumberValidated = validatePhoneNumber(clientPhoneInput.value);

    // Check Kaja form validation (if available)
    const kajaFormValid = window.kajaFormValid || false;

    // firstNameInputEmpty && firstNameInput.classList.add("validate_fail");
    // lastNameInputEmpty && lastNameInput.classList.add("validate_fail");
    // emailInputEmpty && clientEmailInput.classList.add("validate_fail");
    // phoneInputEmpty && clientPhoneInput.classList.add("validate_fail");

    const loggedOutShopify =
      ShopifyAnalytics.meta.page.customerId === undefined;

    // Check if in modify appointment flow
    const appointmentServiceId = localStorage.getItem("appointmentServiceId");
    const concurrencyCheckDigits = localStorage.getItem(
      "concurrencyCheckDigits"
    );
    const isModifyFlow = appointmentServiceId && concurrencyCheckDigits;

    // Skip payment validation if in modify flow
    if (isModifyFlow) {
      if (
        (phoneNumberValidated || !loggedOutShopify) &&
        emailValidated &&
        !firstNameInputEmpty &&
        !lastNameInputEmpty &&
        !emailInputEmpty &&
        !phoneInputEmpty
      ) {
        passValidation = true;
      }
    } else {
      if (
        (phoneNumberValidated || !loggedOutShopify) &&
        emailValidated &&
        !firstNameInputEmpty &&
        !lastNameInputEmpty &&
        !emailInputEmpty &&
        !phoneInputEmpty &&
        !paymentTermsUnchecked &&
        !cardholderNameEmpty &&
        !avsZipEmpty &&
        kajaFormValid
      ) {
        passValidation = true;
      } else {
        // set border of input to be red
      }
    }
  }
  return passValidation;
};

function updateStepLabel(stepIndex, newLabel) {
  const stepElements = document.querySelectorAll("#booking-steps .step");
  const labelSpan = stepElements?.[stepIndex]?.querySelector(".label");
  if (labelSpan) {
    if (
      newLabel &&
      typeof newLabel !== "undefined" &&
      newLabel !== "undefined"
    ) {
      labelSpan.textContent = newLabel;
    }
  }
}

/** Sets step
 *
 * @param {Number} stepNumber
 */
const setStep = (stepNumber) => {
  currentStep = stepNumber;
  sendDataToLocalStorage();

  window.localStorage.setItem("step", stepNumber);

  // getStepNumberFromLocalStorage();
  loadSection(stepNumber);
  // read page and set to local storage
  updateStepNavigation(stepNumber);

  if (selectedServiceId) {
    updateBookingInfoDetails(selectedServiceId);
  }

  updateAllStepLabelsFromStorage();

  // Auto-trigger payment when reaching confirmation step (step 4)
  if (stepNumber === 4) {
    // Check if auto-trigger is enabled
    const autoTriggerEnabled =
      localStorage.getItem("autoTriggerPayment") === "true";

    if (autoTriggerEnabled) {
      // Check if in modify appointment flow
      const appointmentServiceId = localStorage.getItem("appointmentServiceId");
      const concurrencyCheckDigits = localStorage.getItem(
        "concurrencyCheckDigits"
      );
      const isModifyFlow = appointmentServiceId && concurrencyCheckDigits;

      // Wait a bit for the DOM to load, then trigger appropriate booking method
      setTimeout(async () => {
        try {
          const clientId = localStorage.getItem("clientId");
          if (!clientId) {
            return;
          }

          if (isModifyFlow) {
            // For modify flow, use bookAppointment (no payment collection)
            await bookAppointment(clientId);
          } else {
            // For new bookings, use bookAndPayAppointment with payment collection
            await bookAndPayAppointment(clientId);
          }
        } catch (error) {
          // Silent fail for auto-trigger
        }
      }, 1000);
    }
  }
};

function updateAllStepLabelsFromStorage() {
  const locationName = localStorage.getItem("locationName");
  const serviceName = localStorage.getItem("info-serviceName");
  const dateTime = localStorage.getItem("bookingTime");

  if (locationName) updateStepLabel(0, locationName);
  if (serviceName) updateStepLabel(1, serviceName);
  if (dateTime) {
    const formatted = formatCustomDate(dateTime)
      .replace("AM", "am")
      .replace("PM", "pm");
    updateStepLabel(2, formatted);
  }
}

const handleProgressBarClick = (step) => {
  const completedStep = window.localStorage.getItem("completedStep");
  if (step <= completedStep) {
    setStep(step);
  }
};

const sendBooking = async () => {
  // Show loading dialogue
  const loadingDialogue = document.getElementById("loading-dialogue");
  if (loadingDialogue) {
    loadingDialogue.style.display = "flex";
  }

  try {
    const firstName = window.localStorage.getItem("new_client_first_name");
    const lastName = window.localStorage.getItem("new_client_last_name");
    const clientEmail = window.localStorage.getItem("new_client_email");
    const clientNumber = window.localStorage.getItem("new_client_number");
    window.localStorage.setItem("info-client_number", clientNumber);

    const firstNameShopify = document.getElementById(
      "RegisterForm-FirstName"
    ).value;
    const lastNameShopify = document.getElementById(
      "RegisterForm-LastName"
    ).value;
    const clientEmailShopify =
      document.getElementById("RegisterForm-email").value;

    const providers = window.localStorage.getItem("provider").split(",");
    const startTime = window.localStorage.getItem("bookingTime");
    const resource = window.localStorage.getItem("location");
    const serviceId = window.localStorage.getItem("serviceId");
    let clientId = window.localStorage.getItem("clientId");
    const noteBody = window.localStorage.getItem("Note");

    // init for modify flow
    const appointmentServiceId = localStorage.getItem("appointmentServiceId");
    const concurrencyCheckDigits = localStorage.getItem(
      "concurrencyCheckDigits"
    );
    const takenSlots = localStorage.getItem("takenSlots");

    // promo code
    const promo = window.localStorage.getItem("promo");
    const forceResourceId =
      serviceId === "16bc605b-cfb8-4a66-a5ec-b2a40150067f"
        ? "21099b47-b02b-4d64-9c4e-b2a90129b4c8"
        : "e2eb9377-b357-4fb0-ae4c-b2a90129e1f7";

    // thirdpartyid - kaja customer ID
    // const thirdPartyId = localStorage.getItem("thirdPartyId");
    // Function to collect payment data from the form
    const collectPaymentData = async () => {
      // Get form data
      const cardholderName =
        document.getElementById("cardholder-name")?.value?.trim() || "";
      const avsZip = document.getElementById("avs-zip")?.value?.trim() || "";

      // Validate form data
      if (!cardholderName) {
        throw new Error("Please enter the cardholder name");
      }

      if (!avsZip) {
        throw new Error("Please enter your ZIP code");
      }

      let currentToken = null;

      // Get token from Kaja iframe
      if (
        typeof window.HostedTokenization !== "undefined" &&
        window.hostedTokenization
      ) {
        try {
          // Clear any cached validation nonce to ensure we get a fresh token
          if (window.kajaValidationNonce) {
            delete window.kajaValidationNonce;
          }

          // Generate a fresh nonce token for payment processing
          const result = await window.hostedTokenization.getNonceToken();

          if (result && result.token) {
            currentToken = result.token;
          } else if (result && result.nonce) {
            currentToken = result.nonce;
          }

          // Extract expiry information from result if available
          if (result && result.expiryMonth) {
            window.paymentExpiryMonth = result.expiryMonth;
          }

          if (result && result.expiryYear) {
            window.paymentExpiryYear = result.expiryYear;
          }

          // Log token generation for debugging
          console.log(
            "🎫 Fresh payment token generated:",
            currentToken ? "✓" : "✗"
          );
        } catch (tokenError) {
          console.error("❌ Token generation failed:", tokenError);
          throw new Error(
            "Failed to process card information. Please check your card details and try again."
          );
        }
      } else {
        throw new Error(
          "Payment system is not available. Please refresh the page."
        );
      }

      if (!currentToken) {
        throw new Error(
          "Please enter valid card information in the card fields"
        );
      }

      // Prepare payment data
      const paymentData = {
        name: cardholderName,
        source: currentToken,
        avsZip: avsZip,
        // thirdPartyId: thirdPartyId || "",
      };

      // Add expiry fields if available
      if (window.paymentExpiryMonth) {
        paymentData.expiryMonth = window.paymentExpiryMonth;
      }

      if (window.paymentExpiryYear) {
        paymentData.expiryYear = window.paymentExpiryYear;
      }

      return paymentData;
    };

    // Nested function to book an appointment with payment
    const bookAndPayAppointment = async (clientId, paymentData = null) => {
      console.log("🚀 bookAndPayAppointment started", {
        clientId,
        paymentData,
      });

      // If no payment data provided, collect it from the form
      if (!paymentData) {
        console.log("📝 No payment data provided, collecting from form...");
        paymentData = await collectPaymentData();
        console.log("💳 Payment data collected:", paymentData);
      }

      const bookingData = {
        ServiceId: serviceId,
        StartTime: startTime,
        ClientId: clientId,
        EmployeeId: providers[0],
        ResourceId: resource,
        firstName: firstName,
        lastName: lastName,
        email: clientEmail,
        number: clientNumber,
        countryCode: "1",
      };

      //assign booking fee to booking data
      const service = serviceIds.find((service) => service.id === serviceId);
      if (service) {
        bookingData.amount = service.bookingFee;
      }

      console.log("📋 Initial booking data:", bookingData);

      // Add payment data if provided
      if (paymentData) {
        console.log("💰 Adding payment data to booking...");
        // Add payment fields directly to booking data (not nested)
        bookingData.name = paymentData.name;
        bookingData.source = paymentData.source;
        bookingData.avsZip = paymentData.avsZip;

        if (paymentData.expiryMonth) {
          bookingData.expiryMonth = paymentData.expiryMonth;
        }

        if (paymentData.expiryYear) {
          bookingData.expiryYear = paymentData.expiryYear;
        }

        console.log("💳 Final booking data with payment:", bookingData);
      }

      const endpoint =
        "https://cleavage-clinic.uc.r.appspot.com/appointments/bookandpay";

      console.log("🌐 Making API request to:", endpoint);

      try {
        const data = await fetchAsync(
          endpoint,
          "POST",
          JSON.stringify(bookingData)
        );

        console.log("📡 API response received:", data);

        // Check for payment errors first
        if (data.ERROR) {
          console.log("❌ Payment error detected:", data.ERROR);
          // Use global function if available, otherwise fallback to direct DOM manipulation
          if (typeof window.showPaymentError === "function") {
            console.log("🔧 Using global showPaymentError function");
            window.showPaymentError("Error: " + data.ERROR);
          } else {
            console.log("🔧 Using direct DOM manipulation for error display");
            const paymentErrorDiv = document.getElementById(
              "payment-error-message"
            );
            if (paymentErrorDiv) {
              console.log("📝 Updating payment error div");
              // Actual error message
              // paymentErrorDiv.textContent = "Error: " + data.ERROR;

              // Generic error message
              paymentErrorDiv.textContent =
                "An error occurred. Please try again.";
              paymentErrorDiv.classList.remove("hidden");
            } else {
              console.log("⚠️ Payment error div not found");
            }
          }
          console.log("💥 Full error data:", data);
          throw new Error(data.ERROR);
        }

        if (data.appointmentId === "error") {
          console.log("⚠️ Appointment booking returned error:", data.message);
          const validationFailures = data.message.validationFailures;
          if (validationFailures) {
            console.log("📋 Validation failures:", validationFailures);
            alert(
              "Please pick another time:\n" + validationFailures.join("\n")
            );
            setStep(currentStep - 1);
          } else if (data.message.message) {
            let message = data.message.message.split("|")[0].trim();
            console.log("📝 Error message:", message);
            alert(message);
            setStep(currentStep - 1);
          }
        } else if (data.appointmentId) {
          console.log(
            "✅ Appointment booked successfully! ID:",
            data.appointmentId
          );
          console.log("💾 Storing appointment data in localStorage...");

          localStorage.setItem("appointmentId", data.appointmentId);
          // concurrencyCheckDigits: Required for modify/cancel appointment
          localStorage.setItem(
            "concurrencyCheckDigits",
            data.concurrencyCheckDigits
          );
          // needed for modify
          localStorage.setItem("originalProvider", providers[0]);
          localStorage.setItem("originalSlots", takenSlots);
          localStorage.setItem("originalServiceId", serviceId);

          // Required for cancelation
          localStorage.setItem(
            "appointmentServiceId",
            data.appointmentServiceId
          );

          console.log("🎯 Updating confirmation code display");
          document.getElementById("confirmation-code").innerText =
            data.appointmentId;

          console.log("➡️ Moving to next step");
          setStep(currentStep + 1);
        }
        // add note section
        if (noteBody || promo) {
          console.log("📝 Adding note to appointment...", { noteBody, promo });
          const noteData = {
            AppointmentId: data.appointmentId,
            ConcurrencyCheckDigits: localStorage.getItem(
              "concurrencyCheckDigits"
            ),
            noteBody:
              (noteBody || " ") +
              ((promo && "\n--- promo ---\n" + promo) || ""),
          };

          console.log("📋 Note data:", noteData);

          const reqNote = await fetchAsync(
            "https://cleavage-clinic.uc.r.appspot.com/appointments/note",
            "PUT",
            JSON.stringify(noteData)
          );

          console.log("📝 Note API response:", reqNote);

          if (reqNote) {
            if (reqNote.concurrencyCheckDigits) {
              console.log(
                "🔄 Updating concurrency check digits from note response"
              );
              localStorage.setItem(
                "concurrencyCheckDigits",
                reqNote.concurrencyCheckDigits
              );
            }
          }
        }
      } catch (error) {
        console.log("💥 Error in bookAndPayAppointment:", error);
        throw error; // Re-throw to let calling code handle it
      }
    };

    // Legacy function for backward compatibility
    const bookAppointment = async (clientId) => {
      return await bookAndPayAppointment(clientId, null);
    };

    // Expose the new function globally for payment integration
    window.bookAndPayAppointment = bookAndPayAppointment;

    // Nested function to modify an appointment with payment
    const modifyAppointment = async () => {
      const bookingData = {
        AppointmentServiceId: appointmentServiceId,
        ConcurrencyCheckDigits: concurrencyCheckDigits,
        ServiceId: serviceId,
        StartTime: startTime,
        ClientId: clientId,
        EmployeeId: providers[0],
        ResourceId: resource,
      };

      try {
        const data = await fetchAsync(
          "https://cleavage-clinic.uc.r.appspot.com/appointments/book",
          "PUT",
          JSON.stringify(bookingData)
        );

        if (data.appointmentId === "error") {
          // todo
        } else if (data.concurrencyCheckDigits) {
          // concurrencyCheckDigits: Required for modify/cancel appointment
          localStorage.setItem(
            "concurrencyCheckDigits",
            data.concurrencyCheckDigits
          );
          // needed for modify
          localStorage.setItem("originalProvider", providers[0]);
          localStorage.setItem("originalSlots", takenSlots);

          [
            "bookingTime",
            "desiredDate",
            // "desiredTime",
            "provider",
            "serviceId",
          ].forEach((key) => localStorage.removeItem(key));

          // Don't need to update appointmentServiceId as it stays the same
          // update all state

          // localStorage.setItem("StartTime", data.appointmentDate)

          setStep(currentStep + 1);
        }
        // add note section

        const noteData = {
          AppointmentId: data.appointmentId,
          ConcurrencyCheckDigits: localStorage.getItem(
            "concurrencyCheckDigits"
          ),
          noteBody:
            (noteBody || " ") + ((promo && "\n--- promo ---\n" + promo) || ""),
        };

        const reqNote = await fetchAsync(
          "https://cleavage-clinic.uc.r.appspot.com/appointments/note",
          "PUT",
          JSON.stringify(noteData)
        );
        if (reqNote) {
          if (reqNote.concurrencyCheckDigits) {
            localStorage.setItem(
              "concurrencyCheckDigits",
              reqNote.concurrencyCheckDigits
            );
          }
        }
      } catch (error) {}
    };

    const strippedClientNumber = clientNumber.replace(/[\s\-\(\)]/g, "");

    //Check if serviceId has changed for modify
    const originalService = window.localStorage.getItem("originalServiceId");
    const serviceHasChanged = originalService !== serviceId;

    if (appointmentServiceId && concurrencyCheckDigits) {
      if (serviceHasChanged) {
        await cancelAppointment((keepLS = true));
        await bookAppointment(clientId);
      } else {
        await modifyAppointment();
      }
      // return;
    } else if (!clientId || clientId === "undefined") {
      // If client doesn't exist, create one first
      const clientData = {
        firstName: firstName || firstNameShopify,
        lastName: lastName || lastNameShopify,
        countryCode: "1",
        number: strippedClientNumber || "0000",
        email: clientEmail || clientEmailShopify,
      };

      try {
        const data = await fetchAsync(
          "https://cleavage-clinic.uc.r.appspot.com/clients/",
          "POST",
          JSON.stringify(clientData)
        );

        clientId = data.data.clientId;
        localStorage.setItem("clientId", clientId);

        // Book appointment after creating client
        await bookAppointment(clientId);
      } catch (error) {}
    } else {
      // If client exists, book appointment directly
      await bookAppointment(clientId);
    }
  } catch (error) {
    // Handle any errors that occur during the booking process
    console.error("Booking error:", error);
  } finally {
    // Hide loading dialogue
    const loadingDialogue = document.getElementById("loading-dialogue");
    if (loadingDialogue) {
      loadingDialogue.style.display = "none";
    }
  }
};

const getStepNumberFromLocalStorage = () => {
  const step = Number(localStorage.getItem("step"));
  currentStep = sectionIds[step] ? step : 0;
};

function populateCreateAccountForm() {
  const form = document.getElementById("create-account-form");
  const passwordInput = document.getElementById("RegisterConfirmPassword");

  const hiddenFirst = document.getElementById("HiddenFirstName");
  const hiddenLast = document.getElementById("HiddenLastName");
  const hiddenEmail = document.getElementById("HiddenEmail");
  const hiddenPassword = document.getElementById("HiddenPassword");

  if (
    !form ||
    !passwordInput ||
    !hiddenFirst ||
    !hiddenLast ||
    !hiddenEmail ||
    !hiddenPassword
  )
    return;

  hiddenFirst.value = localStorage.getItem("new_client_first_name") || "";
  hiddenLast.value = localStorage.getItem("new_client_last_name") || "";
  hiddenEmail.value = localStorage.getItem("new_client_email") || "";
  hiddenPassword.value = passwordInput.value.trim();

  form.addEventListener("submit", function (e) {
    const password = passwordInput.value.trim();
    const missingFields = [];

    // Validate password length
    if (password.length <= 5) {
      e.preventDefault();

      missingFields.push("Password must be at least 5 characters");
    }

    if (!hiddenFirst.value) missingFields.push("First Name");
    if (!hiddenLast.value) missingFields.push("Last Name");
    if (!hiddenEmail.value) missingFields.push("Email");
    if (!password) missingFields.push("Password");

    if (missingFields.length > 0) {
      e.preventDefault();
      alert(
        "Please fill out the following required field(s):\n" +
          missingFields.join(", ")
      );
      return; // Exit early to prevent form submission
    }

    hiddenPassword.value = password;
  });
}

function watchAndStoreFormInputs() {
  const emailInput = document.getElementById("RegisterForm-email");
  const firstNameInput = document.getElementById("RegisterForm-FirstName");
  const lastNameInput = document.getElementById("RegisterForm-LastName");
  const phoneInput = document.getElementById("RegisterForm-phone");

  const updateLocalStorage = () => {
    if (emailInput) {
      localStorage.setItem("new_client_email", emailInput.value.trim());
    }
    if (firstNameInput) {
      localStorage.setItem(
        "new_client_first_name",
        firstNameInput.value.trim()
      );
    }
    if (lastNameInput) {
      localStorage.setItem("new_client_last_name", lastNameInput.value.trim());
    }
    if (phoneInput) {
      const strippedPhone = phoneInput.value.replace(/[\s\-\(\)]/g, "").trim();

      localStorage.setItem("new_client_number", strippedPhone);
    }
  };

  if (emailInput) emailInput.addEventListener("input", updateLocalStorage);
  if (firstNameInput)
    firstNameInput.addEventListener("input", updateLocalStorage);
  if (lastNameInput)
    lastNameInput.addEventListener("input", updateLocalStorage);
  if (phoneInput) phoneInput.addEventListener("input", updateLocalStorage);
}

const updateServiceId = (serviceId) => {
  const currentServiceId = window.localStorage.getItem("serviceId");

  window.localStorage.setItem("serviceId", serviceId);

  const serviceId0 = localStorage.getItem("serviceId");

  const service = servicesList.find(
    (pkg) =>
      pkg.packageServices.some((service) => service.serviceId === serviceId0) ||
      pkg.serviceId === serviceId0
  );

  if (service?.packageServices?.length >= 2) {
    const packageName = service.packageName;
    const serviceItems = service.packageServices;

    const foundItem = serviceItems.find(
      (item) => item.serviceId === serviceId0
    );

    window.localStorage.setItem(
      "serviceName",
      `${packageName}_${foundItem.serviceName}`
    );
  } else {
    window.localStorage.setItem("serviceName", service?.displayName);
  }

  if (currentServiceId !== serviceId) {
    window.isServiceChange = true;

    [
      "desiredDate",
      //  "desiredTime",
      "provider",
      "bookingTime",
    ].forEach((key) => localStorage.removeItem(key));

    document.querySelector("[data-vc-date-today]").childNodes[0].click();
  }
};

const sendDataToLocalStorage = () => {
  const checkedService = document.querySelector(
    'input[name="service"]:checked'
  );
  if (checkedService) {
    updateServiceId(checkedService.id);
  }

  if (
    sectionIds[currentStep] === "booking-confirm-info" ||
    sectionIds[currentStep] === "booking-confirmation"
  ) {
    populateCreateAccountForm();
    const emailInput = document.getElementById("RegisterForm-email");
    const firstNameInput = document.getElementById("RegisterForm-FirstName");
    const lastNameInput = document.getElementById("RegisterForm-LastName");
    const phoneInput = document.getElementById("RegisterForm-phone");
    if (emailInput) {
      localStorage.setItem("new_client_email", emailInput.value.trim());
    }

    if (firstNameInput) {
      localStorage.setItem(
        "new_client_first_name",
        firstNameInput.value.trim()
      );
    }
    if (lastNameInput) {
      localStorage.setItem("new_client_last_name", lastNameInput.value.trim());
    }
    if (phoneInput) {
      const strippedPhone = phoneInput.value.replace(/[\s\-\(\)]/g, "").trim();
      localStorage.setItem("new_client_number", strippedPhone);
    }
  }
};

/** Shows the corresponding section to the step number
 *
 * @param {Number} stepNumber
 */
const loadSection = (stepNumber) => {
  hideAllSections();
  handleSectionAction(sectionIds[stepNumber]);
  showSection(sectionIds[stepNumber]);
  updateUIForStep(sectionIds[stepNumber]);
};

const hideAllSections = () => {
  sectionIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add("booking_hidden");
    } else {
    }
  });
};

const showSection = (id) => {
  const visibleSection = document.getElementById(id);
  if (visibleSection) {
    visibleSection.classList.remove("booking_hidden");
  } else {
  }
};

const updateUIForStep = (stepId) => {
  const stepsWrapper = document.querySelector(".booking-steps-wrapper");
  if (stepsWrapper) {
    stepsWrapper.style.display =
      stepId === "booking-confirmation" ? "none" : "";
  }

  const navButtons = document.querySelector(".booking-nav-buttons");
  if (navButtons) {
    navButtons.style.display = stepId === "booking-location" ? "none" : "";
  }

  document.querySelectorAll("[data-step='prev']").forEach((btn) => {
    btn.style.display = stepId === "booking-location" ? "none" : "";
  });

  document.querySelectorAll("[data-step='next']").forEach((btn) => {
    btn.style.display =
      stepId === "booking-location" || stepId === "booking-confirmation"
        ? "none"
        : "";
  });

  const labelMap = {
    "booking-location": "",
    "booking-service": "Date & Time",
    "booking-calendar": "Confirm",
  };

  document.querySelectorAll("[data-step='next']").forEach((btn) => {
    const label = btn.querySelector(".label");
    if (label) {
      label.textContent = labelMap[stepId] || "";
    }
  });
};

const arrowSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
  <path d="M11.9998 3.5L5.58317 9.91667L2.6665 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const updateStepNavigation = (stepIndex) => {
  // Track last completed step, never decreases
  let completedStep = stepIndex - 1;

  // Prevent marking step 0 as completed on initial load
  if (completedStep < 0) {
    // completedStep = -1;
  } else if (stepIndex === 4) {
    completedStep = 4;
  }

  const prevCompletedStep = parseInt(
    window.localStorage.getItem("completedStep") || "-1",
    10
  );

  // Only update localStorage if we're moving forward
  if (completedStep > prevCompletedStep) {
    window.localStorage.setItem("completedStep", completedStep);
  }

  // Get the latest completed step from storage
  completedStep = parseInt(
    window.localStorage.getItem("completedStep") || "-1",
    10
  );

  ///////

  document.querySelectorAll(".booking-steps .step").forEach((step) => {
    const circle = step.querySelector(".circle");
    if (circle && !step.hasAttribute("data-original-svg")) {
      step.setAttribute("data-original-svg", circle.innerHTML);
    }
  });

  // update elements in DOM
  const stepElements = document.getElementById("booking-steps");
  for (let i = 0; i < stepElements.children.length; i++) {
    stepElements.children[i].classList.remove("active");
    if (i === stepIndex) {
      stepElements.children[i].classList.add("active");
    }

    if (i <= completedStep) {
      stepElements.children[i].classList.add("completed");
    }

    const circle = stepElements.children[i].querySelector(".circle");
    const line = stepElements.children[i - 1]?.querySelector(".line");
    const originalSVG =
      stepElements.children[i].getAttribute("data-original-svg");

    // step.classList.toggle("active", index <= stepIndex);

    if (line) {
      line.style.display = "block";
      line.style.backgroundColor = i <= stepIndex ? "#667B61" : "#B5BDB3";
      line.style.height = i <= stepIndex ? "2px" : "1px";
    }

    if (i <= completedStep && circle) {
      circle.innerHTML = arrowSVG;
    } else if (circle && originalSVG) {
      circle.innerHTML = originalSVG;
    }
  }
};

/** Populates booking info step with service details
 *
 */
const updateBookingInfoDetails = () => {
  // Booking Info Page
  const info__service = document.getElementById(
    "booking-confirm-info__service"
  );
  const info__subtitle = document.getElementById(
    "booking-confirm-info__subtitle"
  );
  const info__dateTime = document.getElementById(
    "booking-confirm-info__datetime"
  );
  // Booking Confirm Page
  const confirm__service = document.getElementById(
    "booking-confirmation__service"
  );
  const confirm__subtitle = document.getElementById(
    "booking-confirmation__subtitle"
  );
  const confirm__dateTime = document.getElementById(
    "booking-confirmation__datetime"
  );

  let bookingTime = localStorage.getItem("bookingTime");
  const serviceId0 = localStorage.getItem("serviceId");

  // const service = servicesList.find((s) => s.serviceId === serviceId0);
  // const result = servicesList.find(pkg => pkg.serviceId === serviceId0);
  const service = servicesList.find(
    (pkg) =>
      pkg.serviceId === serviceId0 ||
      pkg.packageServices.some((service) => service.serviceId === serviceId0)
  );

  function splitOnUnderscore(str) {
    if (str?.includes("_")) {
      const [before, ...afterParts] = str.split("_");
      const after = afterParts.join("_"); // In case there's more than one underscore
      return { before, after };
    } else {
      return { before: str, after: null };
    }
  }

  const infoServiceName = localStorage.getItem("info-serviceName");
  const infoProductServiceName = localStorage.getItem(
    "info-productServiceName"
  );

  // set items to local storage in case of page reload (Shopify account creation/failure)
  // Saves booking confirmation content
  if (service && service.displayName && service.displayName !== "undefined") {
    const productServiceName = splitOnUnderscore(service?.displayName);

    localStorage.setItem("info-serviceName", productServiceName.before);
    localStorage.setItem("info-productServiceName", productServiceName.after);
  }

  info__service.innerText = infoServiceName;
  confirm__service.innerText = infoServiceName;
  info__subtitle.innerText =
    infoProductServiceName === "null" ? "" : infoProductServiceName;
  confirm__subtitle.innerText =
    infoProductServiceName === "null" ? "" : infoProductServiceName;

  if (bookingTime) {
    if (info__dateTime)
      info__dateTime.innerText = formatCustomDate(bookingTime);
    if (confirm__dateTime)
      confirm__dateTime.innerText = formatCustomDate(bookingTime);
  }
};

// To do: turn above into separate function for populating confirm info section
const populateConfirmInfoSection = () => {
  // document elements
  const info__service = document.getElementById(
    "booking-confirm-info__service"
  );
  const info__subtitle = document.getElementById(
    "booking-confirm-info__subtitle"
  );
  const info__dateTime = document.getElementById(
    "booking-confirm-info__datetime"
  );
  const confirm__service = document.getElementById(
    "booking-confirmation__service"
  );
  const confirm__subtitle = document.getElementById(
    "booking-confirmation__subtitle"
  );
  const confirm__dateTime = document.getElementById(
    "booking-confirmation__datetime"
  );
  const confirm__clientNumber = document.getElementById(
    "booking-confirmation__client_number"
  );
  const confirmationCode = document.getElementById("confirmation-code");

  // local storage
  const info_service = localStorage.getItem("info-serviceName");
  const info_productServiceName = localStorage.getItem(
    "info-productServiceName"
  );
  const info_bookingTime = localStorage.getItem("bookingTime");
  const info_clientNumber = localStorage.getItem("info-client_number");
  const new_clientNumber = localStorage.getItem("new-client_number");
  const confirm_confirmationCode = localStorage.getItem("appointmentId");
  const clientPhone = localStorage.getItem("clientPhone");

  if (info__service) info__service.innerText = info_service;
  if (confirm__service) confirm__service.innerText = info_service;

  info__subtitle.innerText =
    info_productServiceName === "null" ? "" : info_productServiceName;
  confirm__subtitle.innerText =
    info_productServiceName === "null" ? "" : info_productServiceName;
  if (info_bookingTime) {
    info__dateTime.innerText = formatCustomDate(info_bookingTime);
    if (confirm__dateTime)
      confirm__dateTime.innerText = formatCustomDate(info_bookingTime);
  }
  confirm__clientNumber.innerText =
    info_clientNumber || new_clientNumber || clientPhone;
  if (confirm_confirmationCode) {
    confirmationCode.innerText = confirm_confirmationCode;
  }
  // If clientPhone is present in localStorage, set #RegisterForm-phone value and disable it

  const phoneInput = document.getElementById("RegisterForm-phone");
  if (clientPhone && phoneInput) {
    phoneInput.value = clientPhone;
    phoneInput.disabled = true;
  }

  const providerName = localStorage.getItem("providerName");
  const providerTitle = localStorage.getItem("providerTitle");
  const providerInfoEl = document.getElementById("provider-info");

  if (providerInfoEl && providerName) {
    let providerInfoString = `<b class="staff-member">${providerName}</b>`;

    if (providerTitle) {
      providerInfoString = `${providerInfoString}, ${providerTitle}`;
    }

    providerInfoEl.innerHTML = providerInfoString;
  }
};

function populateConfirmationStep() {
  const infoService = localStorage.getItem("info-serviceName");
  const infoSubtitle = localStorage.getItem("info-productServiceName");
  const bookingTime = localStorage.getItem("bookingTime");
  const clientNumber =
    localStorage.getItem("info-client_number") ||
    localStorage.getItem("new-client_number") ||
    localStorage.getItem("clientPhone");
  const appointmentId = localStorage.getItem("appointmentId");
  const providerName = localStorage.getItem("providerName");
  const providerTitle = localStorage.getItem("providerTitle");

  const serviceEl = document.getElementById("booking-confirmation__service");
  const subtitleEl = document.getElementById("booking-confirmation__subtitle");
  const datetimeEl = document.getElementById(
    "booking-confirmation-info__datetime"
  );
  const clientNumberEl = document.getElementById(
    "booking-confirmation__client_number"
  );
  const codeEl = document.getElementById("confirmation-code");
  const providerEl = document.getElementById("confirmed-provider-info");

  if (serviceEl && infoService) serviceEl.innerText = infoService;
  if (subtitleEl)
    subtitleEl.innerText = infoSubtitle === "null" ? "" : infoSubtitle;

  if (datetimeEl && bookingTime) {
    const formattedDate = formatCustomDate(bookingTime);
    datetimeEl.innerText = formattedDate;
  }

  if (clientNumberEl && clientNumber) {
    clientNumberEl.innerText = clientNumber;
  }

  if (codeEl && appointmentId) {
    codeEl.innerText = appointmentId;
  }

  if (providerEl && providerName) {
    let providerString = `<b class="staff-member">${providerName}</b>`;

    if (providerTitle) {
      providerString = `${providerString}, ${providerTitle}`;
    }

    providerEl.innerHTML = providerString;
  }
}

const validateAndBook = () => {
  sendBooking();
};

const initBooking = async () => {
  // getStepNumberFromLocalStorage();
  // if (currentStep === null || isNaN(currentStep)) {
  //   currentStep = 0;
  //   localStorage.setItem("step", "0");
  // }

  const urlParams = new URLSearchParams(window.location.search);
  const isSaved = urlParams.get("saved");

  const appointmentServiceId = localStorage.getItem("appointmentServiceId");
  const concurrencyCheckDigits = localStorage.getItem("concurrencyCheckDigits");

  if (appointmentServiceId && concurrencyCheckDigits) {
    modifyFlow = true;
  }

  if (isSaved) {
    getStepNumberFromLocalStorage();
    populateCreateAccountForm();
  } else {
    currentStep = 0;
    localStorage.setItem("step", "0");
    localStorage.setItem("completedStep", "-1");

    [
      "appointmentId",
      "appointmentServiceId",
      "bookingTime",
      "concurrencyCheckDigits",
      "desiredDate",
      "desiredTime",
      "location",
      "originalProvider",
      "originalSlots",
      "provider",
      "serviceId",
      "takenSlots",
      "thirdPartyId",
    ].forEach((key) => localStorage.removeItem(key));
  }

  loadSection(currentStep);
  updateStepNavigation(currentStep);
  updateAllStepLabelsFromStorage();

  const loggedOutShopify = ShopifyAnalytics.meta.page.customerId === undefined;
  const clientEmailShopify =
    document.getElementById("RegisterForm-email").value;
  const clientId = localStorage.getItem("clientId");

  if (!clientId && loggedOutShopify) {
    window.location.href = "https://cleavageclinic.com/account/login";
  }

  // get clientId from meevo if logged into shopify
  if (clientEmailShopify && !loggedOutShopify && !clientId) {
    fetchAsync(
      `https://cleavage-clinic.uc.r.appspot.com/clients/email/${clientEmailShopify}`,
      "POST"
    )
      .then((data) => {
        console.log("meevo data", data);
        if (data.thirdPartyId) {
          localStorage.setItem("thirdPartyId", data.thirdPartyId);
        }
        if (data.clientId) {
          localStorage.setItem("clientId", data.clientId);
        }
        if (data.maskedPhoneNumber) {
          localStorage.setItem("clientPhone", data.maskedPhoneNumber);
          document.getElementById("RegisterForm-phone").value =
            data.maskedPhoneNumber;
          document.getElementById("RegisterForm-phone").disabled = true;

          document.getElementById(
            "booking-confirmation__client_number"
          ).innerText = data.maskedPhoneNumber;
        }
      })
      .catch((reason) => {});
  }

  // service page

  const bookingService_list = document.getElementById("booking-service_list");
  bookingService_list.addEventListener("change", (event) => {
    const serviceId = event.target.id;

    updateServiceId(serviceId);
    updateBookingInfoDetails(serviceId);
  });

  // calendar Page

  // populate dropdowns with staff
  // To Do: pull from meevo
  const getEmployees = async () => {
    try {
      const data = await fetchAsync(
        "https://cleavage-clinic.uc.r.appspot.com/appointments/",
        "GET"
      );
      if (data) {
        const selectProvider = document.getElementById("provider");

        data.forEach((employee) => {
          const option = document.createElement("option");
          option.text = `${employee.Name}, ${employee.Title}`;
          option.value = employee.employeeId;

          selectProvider.add(option);
        });
      }
    } catch (error) {}
  };

  await getEmployees();

  // location selection Step
  document.querySelectorAll(".booking_location_selection").forEach((block) => {
    block.addEventListener("click", () => {
      const radio = block.querySelector("input[type=radio]");
      const label = block.querySelector(".location-label");
      if (!radio || !label) return;

      const location = radio.value;
      const locationName = label.textContent.trim();

      localStorage.setItem("location", location);
      localStorage.setItem("locationName", locationName);
      updateStepLabel(0, locationName);
      radio.checked = true;
      setStep(1); // Explicitly go to next step
    });
  });

  // Destructure the Calendar constructor
  const { Calendar } = window.VanillaCalendarPro;

  // Create a calendar instance and initialize it.
  let initialDate = localStorage.getItem("desiredDate");

  if (!initialDate || initialDate === "undefined") {
    initialDate = new Date();

    localStorage.setItem("desiredDate", getTodayDate());
  }

  const options = {
    selectedTheme: "light",
    dateMin: getTodayDate(),
    displayDisabledDates: false,
    enableDateToggle: false,
    selectionYearsMode: "only-arrows",
    selectionMonthsMode: "only-arrows",
    firstWeekday: 0,
    selectedWeekends: [],
    selectedDates: [initialDate],
    locale: {
      months: {
        short: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ],
        long: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
      weekdays: {
        short: ["SU", "M", "TU", "W", "TH", "F", "SA"],
        long: ["SU", "M", "TU", "W", "TH", "F", "SA"],
      },
    },
    onInit(self) {},

    onClickDate(self) {
      selectedCalendarDate = self.context.selectedDates[0];
      localStorage.setItem("desiredDate", self.context.selectedDates[0]);
      // get openings from
      fetchAllOpeningsForEmployees(employeeList, selectedCalendarDate);
    },
    onClickMonth(self, event) {},
    onClickArrow(self, event) {},
  };

  const calendar = new Calendar("#calendar", options);
  calendar.init();

  const selectProvider = document.getElementById("provider");

  const selectDesiredTime = document.getElementById("desired_time");

  niceSelectProvider = NiceSelect.bind(selectProvider);
  niceselectDesiredTime = NiceSelect.bind(selectDesiredTime);
  niceselectDesiredTime.disable();

  const setNiceSelectValue = (selectElement, localStorageKey) => {
    const value = localStorage.getItem(localStorageKey);
    if (value) {
      const niceSelect = selectElement.nextElementSibling;
      const option = niceSelect.querySelector(`[data-value="${value}"]`);
      if (option) {
        option.click();
        niceSelect.classList.remove("open");
      }
    }
  };

  setNiceSelectValue(selectDesiredTime, "desiredTime");
  setNiceSelectValue(selectProvider, "provider");

  const isFreeConsultation =
    selectedServiceId &&
    freeConsultationServiceIdArray.includes(selectedServiceId);

  if (isFreeConsultation) {
    niceSelectProvider.disable();
  } else {
    niceSelectProvider.enable();
  }

  // Initialize employee openings for the selected date
  const selectedDate = localStorage.getItem("desiredDate");

  if (selectedDate) {
    messageSearching().show();
    fetchAllOpeningsForEmployees(employeeList, selectedDate);
  }

  selectProvider.addEventListener("change", (event) => {
    const isAnyProvider = event.target.value === "any";
    const selectedServiceId = window.localStorage.getItem("serviceId");
    const isFreeConsultation =
      selectedServiceId &&
      freeConsultationServiceIdArray.includes(selectedServiceId);

    if (isAnyProvider) {
      const optionValues = [...selectProvider.options]
        .slice(1)
        .map((o) => o.value);
      window.localStorage.setItem("provider", allowedEmployees || optionValues);
    } else {
      window.localStorage.setItem("provider", event.target.value);
    }

    if (!(isAnyProvider && isFreeConsultation)) {
      // Clear bookingTime when provider changes
      localStorage.removeItem("bookingTime");
    }

    updateTimeSlots();
  });

  selectDesiredTime.addEventListener("change", (event) => {
    if (event.target.value === "any") {
      const optionValues = [...selectDesiredTime.options]
        .slice(1)
        .map((o) => o.value);
      window.localStorage.setItem("desiredTime", optionValues);
    } else {
      window.localStorage.setItem("desiredTime", event.target.value);
    }
    // Clear bookingTime when desiredTime changes
    localStorage.removeItem("bookingTime");
    // reload new times
    updateTimeSlots();
  });

  niceselectDesiredTime.enable();

  /** Generated Timeslots
   *  Adds bookingTime to local storage, sets corresponding provider to timeslot
   */
  const listElement = document.getElementById("booking_timeslot_container");
  listElement.addEventListener("change", (event) => {
    const selectedTimeId = event.target.id;
    window.localStorage.setItem("bookingTime", selectedTimeId);

    const timeslot = serviceOpenings?.find(
      ({ startTime }) => startTime === selectedTimeId
    );

    if (timeslot) {
      const providerId = timeslot.employeeId;
      window.localStorage.setItem("provider", providerId);

      if (timeslot.resourceId) {
        window.localStorage.setItem("location", timeslot.resourceId);
      }

      if (timeslot.endTime) {
        window.localStorage.setItem("bookingEndTime", timeslot.endTime);
      }

      const provider = employeeList.find((emp) => emp.id === providerId);
      if (provider) {
        window.localStorage.setItem("providerName", provider.name);
        window.localStorage.setItem("providerName", provider.fullName);
        window.localStorage.setItem("providerTitle", provider.title);
      }

      // save time slots between chosen time
      const startIdx = serviceOpenings.findIndex(
        (slot) => slot.startTime === selectedTimeId
      );
      let endIdx = serviceOpenings.findIndex(
        (slot) => slot.startTime === timeslot.endTime
      );
      if (endIdx === -1) {
        endIdx = serviceOpenings.length - 1;
      }
      const takenSlots = serviceOpenings.slice(startIdx, endIdx + 1);
      localStorage.setItem("takenSlots", JSON.stringify(takenSlots));
    }
    updateNextButtonState();
  });

  if (isSaved) {
    const createAccountForm = document.getElementById("create-account-form");

    if (!createAccountForm) {
      clearStorage(true);
    }
  }
};

/** Updates the DOM with available time slots
 * Get everything from Local storage
 */
function updateTimeSlots() {
  const desired_time = localStorage.getItem("desiredTime") || "08:00";
  const providers = localStorage.getItem("provider")?.split(",");
  const listElement = document.getElementById("booking_timeslot_container");
  const desiredDate = localStorage.getItem("desiredDate");
  // modify flow
  const originalProvider = localStorage.getItem("originalProvider");
  const originalService = localStorage.getItem("originalServiceId");
  const originalSlots = localStorage.getItem("originalSlots");
  const currentService = localStorage.getItem("serviceId");

  let slotsToAppend = null;
  let newDateMatchesOriginalDate = [];

  const isServiceChange = originalService !== currentService;

  if (!isServiceChange) {
    slotsToAppend = JSON.parse(originalSlots);

    newDateMatchesOriginalDate =
      slotsToAppend && desiredDate === slotsToAppend[0].startTime.slice(0, 10);
  }

  const serviceChangedFromProcedureToConsultation =
    currentService.includes("Free Consultation") &&
    currentService !== originalService &&
    !originalService.includes("Free Consultation");
  const serviceChangedFromConsultationToProcedure =
    !currentService.includes("Free Consultation") &&
    currentService !== originalService &&
    !currentService.includes("Free Consultation");

  // Always hide both at start
  messageSearching().hide();
  messageNoTimeslots().hide();

  // desired_time.removeAttribute("enabled", "");
  // destroy current times
  listElement.innerHTML = "";
  // get selected employees
  let startTimes = [];
  let usedTimeslots = []; // prevent duplicates from rendering

  let foundMatchingOpening = false;

  if (
    serviceChangedFromProcedureToConsultation ||
    serviceChangedFromConsultationToProcedure
  ) {
    slotsToAppend = null;
  }

  providers?.forEach((provider) => {
    let employee = employeeList.find((emp) => emp.id === provider);

    if (employee) {
      if (employee.openings.length > 0) {
        matchingOpening = employee.openings.find(
          (entry) => entry.date.slice(0, 10) === desiredDate
        );
      }

      serviceOpenings = [];

      if (matchingOpening) {
        const serviceOpeningsData = matchingOpening?.serviceOpenings;

        for (let i = 0; i < serviceOpeningsData.length; i++) {
          const serviceOpeningItem = serviceOpeningsData[i];

          if (
            serviceOpeningItem.serviceName.includes(
              window.localStorage.getItem("serviceName")
            )
          ) {
            serviceOpenings.push(serviceOpeningItem);
          }

          i++;
        }
      }

      if (serviceOpenings.length > 0) {
        messageSearching().hide();
        // Append dates from original booking for modify flow
        if (
          slotsToAppend &&
          newDateMatchesOriginalDate.length > 0 &&
          originalProvider === provider
        ) {
          slotsToAppend.forEach((timeSlot) => {
            if (startTimes.includes(timeSlot.startTime) === false) {
              if (
                !timeSlot.startTime.endsWith(":00:00.0000000") &&
                !timeSlot.startTime.endsWith(":30:00.0000000")
              ) {
                return;
              }
              startTimes.push(timeSlot.startTime);
            }
          });
        } else if (slotsToAppend) {
          listElement.innerHTML = "";
        }
        // normal flow
        serviceOpenings.forEach((timeSlot) => {
          if (startTimes.includes(timeSlot.startTime) === false) {
            // return if timeslot.startTime is not ending in minutes :00:00.0000000 or :30:00.0000000
            if (
              !timeSlot.startTime.endsWith(":00:00.0000000") &&
              !timeSlot.startTime.endsWith(":30:00.0000000")
            ) {
              return;
            }

            startTimes.push(timeSlot.startTime);
          }
        });

        startTimes.sort();

        const combinedDateTime = `${desiredDate}T${desired_time}:00.0000000`;

        // manually add one hour to get end time
        // set to 2 hours (hour + 2)
        const hour = parseInt(combinedDateTime.slice(11, 13), 10);
        const nextHour = String(hour + 2).padStart(2, "0");
        const end =
          combinedDateTime.slice(0, 11) + nextHour + combinedDateTime.slice(13);

        let filtered = startTimes.filter(
          (ts) => ts >= combinedDateTime && ts < end
        );

        if (
          startTimes.length > 0 &&
          filtered.length === 0 &&
          startTimes[0].startsWith(desiredDate)
        ) {
          // Convert all startTimes to Date objects for comparison
          const startTimesSorted = startTimes.slice().sort();
          // Find the next available time after combinedDateTime
          const nextAvailable = startTimesSorted.find(
            (ts) => ts > combinedDateTime
          );
          if (nextAvailable) {
            // Case 1: There are future time slots available for the date
            // Set combinedDateTime to the next available time
            // Set end to 2 hours after that
            const nextDate = new Date(nextAvailable);
            const endDate = new Date(nextDate.getTime() + 2 * 60 * 60 * 1000);
            const combinedDateTimeNew = nextAvailable;
            const endNew = endDate.toISOString();
            filtered = startTimes.filter(
              (ts) => ts >= combinedDateTimeNew && ts < endNew
            );
          } else {
            // Case 2: No future time slots, so use the last available time
            // Set combinedDateTime to (last available time - 2 hours)
            // Set end to last available time
            const lastAvailable = startTimesSorted[startTimesSorted.length - 1];
            const lastDate = new Date(lastAvailable);
            const startDate = new Date(lastDate.getTime() - 2 * 60 * 60 * 1000);
            const combinedDateTimeNew = toMeevoISOString(startDate);
            const endNew = lastAvailable;
            filtered = startTimes.filter(
              (ts) => ts >= combinedDateTimeNew && ts < endNew
            );
          }
        }

        filtered.forEach((timeSlot) => {
          if (usedTimeslots.includes(timeSlot)) {
            return;
          }
          usedTimeslots.push(timeSlot);

          foundMatchingOpening = true;

          addElementCalendarTime("timeSlot", timeSlot, formatTime(timeSlot));
        });
      }
    }
  });
  if (foundMatchingOpening === false) {
    messageNoTimeslots().show();
  }

  // After timeslots are rendered, select the stored bookingTime if it exists
  const bookingTime = localStorage.getItem("bookingTime");
  if (bookingTime) {
    const timeSlotInput = document.querySelector(
      `#booking_timeslot_container input[id="${bookingTime}"]`
    );
    if (timeSlotInput) {
      timeSlotInput.checked = true;
      updateNextButtonState();
    }
  }
}

/**
 * Robust HTTP request function using Axios
 * Replaces the old fetchAsync function with better error handling, retries, and timeout management
 * @param {string} url - The URL to make the request to
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {string|Object} body - Request body (will be parsed if string)
 * @param {Object} options - Additional options for the request
 * @returns {Promise<Object>} - Response data
 */
async function fetchAsync(url, method = "GET", body = null, options = {}) {
  // Fallback to fetch if Axios is not available
  if (typeof axios === "undefined") {
    console.warn("⚠️ Axios not available, falling back to fetch API");
    try {
      const response = await fetch(url, {
        method: method,
        body: body,
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      });

      if (!response.ok) {
        throw new Error(
          `HTTP error! status: ${response.status} ${response.statusText}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("❌ Fetch fallback failed:", error);
      throw error;
    }
  }

  try {
    // Configure Axios request
    const config = {
      url: url,
      method: method.toLowerCase(),
      timeout: options.timeout || 30000, // 30 second timeout
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        ...options.headers,
      },
      // Retry configuration
      retry: options.retry || 3,
      retryDelay: options.retryDelay || 1000,
      // Validate status codes
      validateStatus: function (status) {
        return status >= 200 && status < 300; // Default range
      },
    };

    // Add request body if provided
    if (body) {
      if (typeof body === "string") {
        try {
          config.data = JSON.parse(body);
        } catch (e) {
          config.data = body;
        }
      } else {
        config.data = body;
      }
    }

    // Add retry interceptor for failed requests
    const axiosInstance = axios.create();

    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const config = error.config;

        // If we haven't set up retry yet, set it up
        if (!config || !config.retry) return Promise.reject(error);

        // If we've exhausted retries, reject
        if (!config.__retryCount) config.__retryCount = 0;
        if (config.__retryCount >= config.retry) {
          return Promise.reject(error);
        }

        // Increment retry count
        config.__retryCount += 1;

        // Only retry on network errors or 5xx server errors
        if (
          error.code === "NETWORK_ERROR" ||
          error.code === "TIMEOUT" ||
          (error.response && error.response.status >= 500)
        ) {
          console.log(
            `🔄 Retrying request (${config.__retryCount}/${config.retry}):`,
            url
          );

          // Wait before retrying
          await new Promise((resolve) =>
            setTimeout(resolve, config.retryDelay * config.__retryCount)
          );

          return axiosInstance(config);
        }

        return Promise.reject(error);
      }
    );

    console.log(`🌐 Making ${method} request to:`, url);
    if (body) console.log(`📤 Request body:`, config.data);

    const response = await axiosInstance(config);

    console.log(`📡 Response received (${response.status}):`, response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Request failed:", {
      url,
      method,
      error: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
    });

    // Handle different types of errors
    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
      throw new Error(
        `Request timed out after ${config.timeout / 1000} seconds`
      );
    }

    if (error.response) {
      // Server responded with error status
      const status = error.response.status;
      const statusText = error.response.statusText;
      throw new Error(`HTTP error! status: ${status} ${statusText}`);
    }

    if (error.request) {
      // Request was made but no response received
      throw new Error("Network error: No response received from server");
    }

    // Something else happened
    throw new Error(`Request failed: ${error.message}`);
  }
}

function handleSectionAction(sectionName) {
  const index = sectionIds.indexOf(sectionName);
  if (index !== -1 && actions[sectionName]) {
    actions[sectionName]();
  } else {
  }
}

// Logic for different sections
function loadLocation() {}

function loadService() {
  if (!loadedServices) {
    fetchAsync("https://cleavage-clinic.uc.r.appspot.com/appointments/services")
      .then((data) => {
        const transformedArray = transformPackages(data);

        console.log(transformedArray);
        // Move "Complimentary Consultation" to top
        transformedArray.sort((a, b) => {
          if (a.packageName === "Complimentary Consultation") return -1;
          if (b.packageName === "Complimentary Consultation") return 1;
          return 0;
        });

        // Move maintenance services to end
        transformedArray.sort((a, b) => {
          if (a.packageName === "Maintenance Session") return 1;
          if (b.packageName === "Maintenance Session") return -1;
          return 0;
        });

        // store serviceList for other functions
        servicesList = transformedArray;

        transformedArray.forEach((item, index) => {
          const {
            packageName,
            packagePrice,
            originalPackagePrice,
            longDesc,
            shortDesc,
            packageServices,
          } = item;

          if (packageServices.length > 1) {
            // move Bra Fat/Flank Fat to end
            const targetService = "Bra Fat/Flank Fat";
            const indexP = packageServices.findIndex(
              (indexP) => indexP.serviceName === targetService
            );

            if (indexP !== -1) {
              const [item] = packageServices.splice(indexP, 1); // remove the item
              packageServices.push(item); // move to the end
            }
            console.log(item, "item");
            if (packageName === "Maintenance Session") {
              addElementServiceMultiWithPrice(
                packageName,
                "From $300",
                "service",
                longDesc || shortDesc,
                index === 0,
                packageServices
              );
            } else {
              addElementServiceMulti(
                packageName,
                packageName === "Complimentary Consultation"
                  ? `($${originalPackagePrice} Value)`
                  : `($${originalPackagePrice} Value)`,
                "service",
                longDesc || shortDesc,
                index === 0,
                packageServices
              );
            }

            // Restore selection for multi-option services
            const savedServiceId = localStorage.getItem("serviceId");
            if (savedServiceId) {
              const input = document.querySelector(
                `.booking-service_label_multi input[type="radio"][id="${savedServiceId}"]`
              );

              if (input) {
                input.checked = true;

                const wrapper = input.closest(
                  ".booking-service_label_multi_wrapper"
                );
                if (wrapper) {
                  wrapper.classList.remove("hidden");

                  const container = wrapper
                    .closest(".booking-service_label")
                    .querySelector(".booking-service_label_text_container");
                  if (container) {
                    container.classList.add("selected");
                  }
                }

                updateBookingInfoDetails(savedServiceId);
              }
            }
          } else {
            addElementServiceSingle(
              packageName,
              packagePrice !== 0
                ? `$${packagePrice}`
                : `($${originalPackagePrice} Value)`,
              "service",
              longDesc || shortDesc,
              index === 0,
              packageServices
            );
          }
        });

        setupServiceMultiToggle();

        // get service from LS and check radio step
        let LSService = localStorage.getItem("serviceId");
        if (LSService) {
          const x = document.getElementById(LSService);
          x.checked = true;
          updateBookingInfoDetails(LSService);
        }
      })
      .catch((reason) => {});

    loadedServices = true;
  }
}
// calendar page
async function loadCalendar() {
  allowedEmployees = [];

  // get employees who can do the chosen service, disable rest
  const currentServiceId = window.localStorage.getItem("serviceId");
  const employeeSelect = document.getElementById("provider");

  const getServiceEmployees = async (serviceId) => {
    try {
      const data = await fetchAsync(
        `https://cleavage-clinic.uc.r.appspot.com/appointments/employees/${serviceId}`,
        "GET"
      );
      if (data) {
        data.forEach((item) => {
          allowedEmployees.push(item.employeeId);
        });

        for (const option of employeeSelect.options) {
          if (option.value === "any") {
          } else {
            option.disabled = !allowedEmployees.includes(option.value);
          }
        }
        niceSelectProvider.update();
      }
    } catch (error) {}
  };
  await getServiceEmployees(currentServiceId);

  if (allowedEmployees.length === 1) {
    window.localStorage.setItem("provider", allowedEmployees[0]);
  }
  // reset openings
  employeeList.forEach((employee) => {
    employee.openings = [];
  });
  // try to get from LS, if localstorage selected date/time is no longer available, remove from localstorage
  let startDate = null;
  let endDate = "2025-04-30";
  const serviceId = window.localStorage.getItem("serviceId");
  if (!serviceId) {
    setStep(currentStep - 1);
    return;
  }
  selectedServiceId = window.localStorage.getItem("serviceId");
  // 1. get all active staff

  // render list of employees to select (provider)

  // set providers to LS
  const providers = document.getElementById("provider");
  let optionValues = [...providers.options].map((o) => o.value).splice(1);

  // special logic for free consultation only
  const isFreeConsultation =
    selectedServiceId &&
    freeConsultationServiceIdArray.includes(selectedServiceId);

  let currentProvider = localStorage.getItem("provider");
  if (!currentProvider || isFreeConsultation) {
    window.localStorage.setItem("provider", allowedEmployees || optionValues);
  }
  //setItem("provider", allowedEmployees || optionValues);
  if (niceSelectProvider) {
    if (isFreeConsultation) {
      const niceSelect = providers.nextElementSibling;
      const option = niceSelect.querySelector(`[data-value="any"]`);
      if (option) {
        option.click();
        niceSelect.classList.remove("open");
      }

      niceSelectProvider.disable();
    } else {
      niceSelectProvider.enable();
    }
  }

  // 2. do a search for the location for each staff member (try to see if possible to pass array of staff members)
  if (employeeList)
    [
      messageSearching().show(),
      fetchAllOpeningsForEmployees(employeeList, getTodayDate()),
    ];
  const appointmentServiceId = localStorage.getItem("appointmentServiceId");
  const concurrencyCheckDigits = localStorage.getItem("concurrencyCheckDigits");
  if (appointmentServiceId && concurrencyCheckDigits) {
    modifyFlow = true;
  }

  // needed to get the dates from the last booking
  if (modifyFlow) {
    employeeList.forEach((employee) => {
      employee.openings = [];
    });

    fetchAllOpeningsForEmployees(employeeList, selectedCalendarDate);
    updateTimeSlots();
  }

  if (window.isServiceChange) {
    document.querySelector("[data-vc-date-today]").childNodes[0].click();

    window.isServiceChange = false;
  }
}

function loadConfirmInfoFromNewUser() {
  const isLoggedIn = window.customerIsLoggedIn;
  if (isLoggedIn) return;

  const emailInput = document.getElementById("RegisterForm-email");
  const phoneInput = document.getElementById("RegisterForm-phone");
  const firstNameInput = document.getElementById("RegisterForm-FirstName");
  const lastNameInput = document.getElementById("RegisterForm-LastName");

  if (phoneInput && !phoneInput.value)
    phoneInput.value = localStorage.getItem("info-client_number") || "";

  if (emailInput && !emailInput.value)
    emailInput.value = localStorage.getItem("new_client_email") || "";

  if (firstNameInput && !firstNameInput.value)
    firstNameInput.value = localStorage.getItem("new_client_first_name") || "";

  if (lastNameInput && !lastNameInput.value)
    lastNameInput.value = localStorage.getItem("new_client_last_name") || "";
}

function loadConfirmInfo() {
  const serviceId = window.localStorage.getItem("serviceId");
  if (!serviceId) {
    setStep(currentStep - 2);
    return;
  }
  loadConfirmInfoFromNewUser();
  populateConfirmInfoSection();

  // Hide payment section if in modify appointment flow
  const appointmentServiceId = localStorage.getItem("appointmentServiceId");
  const concurrencyCheckDigits = localStorage.getItem("concurrencyCheckDigits");
  const isModifyFlow = appointmentServiceId && concurrencyCheckDigits;

  const paymentSection = document.querySelector(".payment-section");
  if (paymentSection) {
    if (isModifyFlow) {
      paymentSection.style.display = "none";
    } else {
      paymentSection.style.display = "";
    }
  }

  // get meevo clientId from shopify and store in localstorage
  // get existing data from meevo
  // Low priority: allow editing
  // if no existing data allow editing
}
function loadConfirmation() {
  populateConfirmationStep();
  // set items to local storage in case of page reload (Shopify account creation/failure)
  // Saves booking confirmation content
  localStorage.setItem("info-bookingTime", localStorage.getItem("bookingTime"));

  const isLoggedIn = window.customerIsLoggedIn;
  if (isLoggedIn) return;

  const emailEl = document.getElementById("booking-confirmation-email");

  if (!isLoggedIn) {
    const email = localStorage.getItem("new_client_email");

    if (emailEl && email) emailEl.textContent = email;
  }
}

function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function formatTime(timeString) {
  const date = new Date(timeString);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 => 12
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return `${hours}:${minutes}${ampm}`;
}

/** formats date for the booking info
 *
 * @param {*} input - iso format
 * @returns
 */
function formatCustomDate(input) {
  const cleaned = input.replace(/\.\d+$/, "");
  const date = new Date(cleaned);
  const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  const parts = date.toLocaleString("en-US", options).split(", ");
  return `${parts[0]} at ${parts[1]}`;
}

/** Combines packages like "Morpheus8_*" into a single item:
 *
 * @param {*} packages
 * @returns
 */
function transformPackages(packages) {
  const grouped = {};

  for (const pkg of packages) {
    const hasUnderscore = pkg.packageName.includes("_");

    if (!hasUnderscore) {
      // Keep original package
      grouped[pkg.packageName] = pkg;
      continue;
    }

    const [baseName, _] = pkg.packageName.split("_");

    if (!grouped[baseName]) {
      grouped[baseName] = {
        ...pkg,
        packageName: baseName,
        packageServices: [],
      };
    }

    const services = pkg.packageServices.map((service) => {
      const serviceNameParts = service.serviceName.split("_");
      return {
        ...service,
        serviceName: serviceNameParts[1] || service.serviceName,
      };
    });

    grouped[baseName].packageServices.push(...services);
  }

  return Object.values(grouped);
}

function groupServiceOpeningsByDate(employeeIndex, newData) {
  let openings = employeeList[employeeIndex].openings;

  newData.forEach((item) => {
    // Check if the date already exists in the grouped data
    let existingGroup = openings.find((group) => group.date === item.date);

    if (existingGroup) {
      // If the date exists, check if the startTime already exists within the same date
      let existingOpening = existingGroup.serviceOpenings.find(
        (opening) => opening.startTime === item.startTime
      );

      if (!existingOpening) {
        // If the startTime does not exist, add the new service opening to the group
        existingGroup.serviceOpenings.push({
          startTime: item.startTime,
          endTime: item.endTime,
          resourceId: item.resourceId,
          resourceName: item.resourceName,
          serviceName: item.serviceName,
          employeeName: item.employeeName,
          employeeId: item.employeeId,
        });
      }
    } else {
      // If the date doesn't exist, create a new group for that date
      openings.push({
        date: item.date,
        serviceOpenings: [
          {
            startTime: item.startTime,
            endTime: item.endTime,
            resourceId: item.resourceId,
            resourceName: item.resourceName,
            serviceName: item.serviceName,
            employeeName: item.employeeName,
            employeeId: item.employeeId,
          },
        ],
      });
    }
  });
}

function addElementServiceSingle(
  packageName,
  packagePrice,
  input_id,
  longDesc,
  isMandatory,
  packageServices
) {
  const listElement = document.getElementById("booking-service_list");

  const divLabelTextContainer = document.createElement("div");
  divLabelTextContainer.className = "booking-service_label_text_container";

  const texttitle = document.createTextNode(packageName + " ");
  const divLabelTextContainer_Title = document.createElement("div");
  divLabelTextContainer_Title.className =
    "booking-service_label_text_container_title";
  divLabelTextContainer_Title.append(texttitle);

  const formattedPackagePrice = String(packagePrice).replace(
    /(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g,
    "$1,"
  );

  const textprice = document.createTextNode(formattedPackagePrice);
  const divPriceText = document.createElement("div");
  divPriceText.className = "booking-service_label_price";
  divPriceText.append(textprice);

  const textdescription = document.createTextNode(longDesc);
  const divDescriptionText = document.createElement("div");
  divDescriptionText.className = "booking-service_label_description";
  divDescriptionText.append(textdescription);

  const listItem = document.createElement("li");
  const label = document.createElement("label");
  label.className = "booking-service_label";
  label.setAttribute("for", packageServices[0].serviceId);
  const input = document.createElement("input");
  input.name = input_id;
  input.id = packageServices[0].serviceId;
  input.type = "radio";
  input.className = "booking-service_input";

  const spanMandatory = document.createElement("span");
  spanMandatory.className = "booking-service_label_mandatory";
  spanMandatory.append(document.createTextNode("Mandatory"));
  isMandatory && divLabelTextContainer_Title.append(spanMandatory);

  divLabelTextContainer.append(divLabelTextContainer_Title);

  const divTitleRow = document.createElement("div");
  divTitleRow.className = "booking-service_label_row";
  divTitleRow.append(divLabelTextContainer, divPriceText);

  label.append(divTitleRow, divDescriptionText);
  listItem.append(input, label);
  listElement.appendChild(listItem);
}

function setupServiceMultiToggle() {
  const allLabels = document.querySelectorAll(".booking-service_label");

  allLabels.forEach((label) => {
    label.addEventListener("click", (e) => {
      const wrapper = label.querySelector(
        ".booking-service_label_multi_wrapper"
      );

      if (wrapper && wrapper.contains(e.target)) return;

      document
        .querySelectorAll(".booking-service_label_text_container.selected")
        .forEach((el) => el.classList.remove("selected"));

      const thisTextContainer = label.querySelector(
        ".booking-service_label_text_container"
      );
      if (thisTextContainer) {
        thisTextContainer.classList.add("selected");
      }

      document
        .querySelectorAll(".booking-service_label_multi_wrapper")
        .forEach((el) => el.classList.add("hidden"));

      document.querySelectorAll('input[name="service"]').forEach((input) => {
        input.checked = false;
      });

      if (wrapper) {
        wrapper.classList.remove("hidden");
        updateServiceId("");
      } else {
        const radio = label.previousElementSibling;
        if (radio && radio.type === "radio" && radio.name === "service") {
          radio.checked = true;
          updateServiceId(radio.id);
        }
      }

      updateNextButtonState();
    });
  });
}

function addElementServiceMulti(
  packageName,
  packagePrice,
  input_id,
  longDesc,
  isMandatory,
  packageServices
) {
  const listElement = document.getElementById("booking-service_list");

  const divLabelTextContainer = document.createElement("div");
  divLabelTextContainer.className = "booking-service_label_text_container";

  const texttitle = document.createTextNode(packageName);
  const divLabelTextContainer_Title = document.createElement("div");
  divLabelTextContainer_Title.className =
    "booking-service_label_text_container_title";
  divLabelTextContainer_Title.append(texttitle);

  const formattedPackagePrice = String(packagePrice).replace(
    /(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g,
    "$1,"
  );

  const textprice = document.createTextNode(formattedPackagePrice);
  const divPriceText = document.createElement("div");
  divPriceText.className = "booking-service_label_price";
  divPriceText.append(textprice);

  const textdescription = document.createTextNode(longDesc);
  const divDescriptionText = document.createElement("div");
  divDescriptionText.className = "booking-service_label_description";
  divDescriptionText.append(textdescription);

  const listItem = document.createElement("li");
  const label = document.createElement("div");
  label.className = "booking-service_label";
  const input = document.createElement("div");
  input.className = "booking-service_input";

  const spanMandatory = document.createElement("span");
  spanMandatory.className = "booking-service_label_mandatory";
  spanMandatory.append(document.createTextNode("Mandatory"));
  isMandatory && divLabelTextContainer_Title.append(spanMandatory);

  divLabelTextContainer.append(divLabelTextContainer_Title);

  const divTitleRow = document.createElement("div");
  divTitleRow.className = "booking-service_label_row";
  divTitleRow.append(divLabelTextContainer, divPriceText);

  label.append(divTitleRow, divDescriptionText);

  const multiOptionWrapper = document.createElement("div");
  multiOptionWrapper.className = "booking-service_label_multi_wrapper hidden";

  packageServices.forEach((service) => {
    if (service.serviceId === "16bc605b-cfb8-4a66-a5ec-b2a40150067f") {
      return;
    }
    const labelMulti = document.createElement("label");
    labelMulti.className = "booking-service_label_multi";

    const inputMulti = document.createElement("input");
    inputMulti.className = "booking-service_input_multi";
    inputMulti.id = service.serviceId;
    inputMulti.name = input_id;
    inputMulti.type = "radio";

    labelMulti.appendChild(inputMulti);

    const serviceLabelText = document.createElement("div");
    serviceLabelText.className = "booking-service_label_multi_text";
    serviceLabelText.textContent = service.serviceName;

    labelMulti.appendChild(serviceLabelText);

    multiOptionWrapper.appendChild(labelMulti);
  });

  label.appendChild(multiOptionWrapper);
  listItem.append(label);
  listElement.appendChild(listItem);
}

function addElementServiceMultiWithPrice(
  packageName,
  packagePrice,
  input_id,
  longDesc,
  isMandatory,
  packageServices
) {
  const listElement = document.getElementById("booking-service_list");

  const divLabelTextContainer = document.createElement("div");
  divLabelTextContainer.className = "booking-service_label_text_container";

  const texttitle = document.createTextNode(packageName);
  const divLabelTextContainer_Title = document.createElement("div");
  divLabelTextContainer_Title.className =
    "booking-service_label_text_container_title";
  divLabelTextContainer_Title.append(texttitle);

  const formattedPackagePrice = String(packagePrice).replace(
    /(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g,
    "$1,"
  );

  const textprice = document.createTextNode(formattedPackagePrice);
  const divPriceText = document.createElement("div");
  divPriceText.className = "booking-service_label_price";
  divPriceText.append(textprice);

  const textdescription = document.createTextNode(longDesc);
  const divDescriptionText = document.createElement("div");
  divDescriptionText.className = "booking-service_label_description";
  divDescriptionText.append(textdescription);

  const listItem = document.createElement("li");
  const label = document.createElement("div");
  label.className = "booking-service_label";
  const input = document.createElement("div");
  input.className = "booking-service_input";

  const spanMandatory = document.createElement("span");
  spanMandatory.className = "booking-service_label_mandatory";
  spanMandatory.append(document.createTextNode("Mandatory"));
  isMandatory && divLabelTextContainer_Title.append(spanMandatory);

  divLabelTextContainer.append(divLabelTextContainer_Title);

  const divTitleRow = document.createElement("div");
  divTitleRow.className = "booking-service_label_row";
  divTitleRow.append(divLabelTextContainer, divPriceText);

  label.append(divTitleRow, divDescriptionText);

  const multiOptionWrapper = document.createElement("div");
  multiOptionWrapper.className = "booking-service_label_multi_wrapper hidden";

  packageServices.forEach((service) => {
    if (service.serviceId === "16bc605b-cfb8-4a66-a5ec-b2a40150067f") {
      return;
    }
    const labelMulti = document.createElement("label");
    labelMulti.className = "booking-service_label_multi";

    const inputMulti = document.createElement("input");
    inputMulti.className = "booking-service_input_multi";
    inputMulti.id = service.serviceId;
    inputMulti.name = input_id;
    inputMulti.type = "radio";

    labelMulti.appendChild(inputMulti);

    const formattedServicePrice = String(service.fullItemPrice).replace(
      /(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g,
      "$1,"
    );

    const serviceLabelText = document.createElement("div");
    serviceLabelText.className = "booking-service_label_multi_text";
    serviceLabelText.textContent =
      (service.serviceName === "Morpheus8"
        ? "Morpheus8 (Lifting & Tightening)"
        : service.serviceName) +
      " - $" +
      formattedServicePrice;

    labelMulti.appendChild(serviceLabelText);

    multiOptionWrapper.appendChild(labelMulti);
  });

  label.appendChild(multiOptionWrapper);
  listItem.append(label);
  listElement.appendChild(listItem);
}

function addElementCalendarTime(input_id, timeStamp, labelTime) {
  const listElement = document.getElementById("booking_timeslot_container");

  const textLabel = document.createTextNode(labelTime);
  const label_text = document.createElement("div");
  label_text.className = "label_text";
  label_text.append(textLabel);

  const label = document.createElement("label");
  label.className = "booking_timeslot";
  label.setAttribute("for", timeStamp);

  const inputElement = document.createElement("input");
  inputElement.className = "booking-service_input_multi";
  inputElement.id = timeStamp;
  inputElement.name = input_id;
  inputElement.type = "radio";
  inputElement.className = "booking-service_input_multi";
  // inputElement.append(serviceLabelText);

  label.append(inputElement, label_text);
  const listItem = document.createElement("li");

  listItem.append(label);

  listElement.appendChild(listItem);
}

/** update timeslots if provider changed and desired time set */
function handleChangeProvider() {
  const desiredDate = localStorage.getItem("desiredDate");
  if (desiredDate) {
    updateTimeSlots();
  }
}

// Function to check if user should have access to booking page
function checkAuthAndRedirect() {
  const loggedOutShopify = ShopifyAnalytics.meta.page.customerId === undefined;
  const hasTempAccess =
    localStorage.getItem("new_client_temp_access") === "true";

  // user is logged in and has temp access (no need to redirect)
  if (!loggedOutShopify && hasTempAccess) {
    localStorage.removeItem("new_client_temp_access");
    return false;
  }
  // Check if user is logged out and doesn't have temporary access
  if (loggedOutShopify && !hasTempAccess) {
    window.location.href = "https://cleavageclinic.com/account/login";
    return true;
  }

  // Additional checks for noAccess or completedBooking
  const tempShopifyCreateAccount = localStorage.getItem(
    "temp-shopify-create-account"
  );
  const noAccess =
    loggedOutShopify && tempShopifyCreateAccount != "true" && !hasTempAccess;

  if (noAccess) {
    [
      "bookingTime",
      "desiredDate",
      "desiredTime",
      "location",
      "clientId",
      "provider",
      "serviceId",
      "step",
    ].forEach((key) => localStorage.removeItem(key));

    window.location.href = "https://cleavageclinic.com/account/login";
    return true;
  }

  // Clean up temporary access flags
  if (tempShopifyCreateAccount && !loggedOutShopify) {
    localStorage.removeItem("temp-shopify-create-account");
  }
  if (!loggedOutShopify) {
    localStorage.removeItem("new_client_temp_access");
  }

  return false;
}

function redirectToFirstStepIfAppointmentDateIsInThePast() {
  if (localStorage.getItem("step") !== "4") {
    return;
  }

  const bookingTime = localStorage.getItem("bookingTime");
  const bookingDate = new Date(bookingTime);
  if (bookingDate < new Date()) {
    clearStorage();

    window.localStorage.setItem("completedStep", "-1");

    window.location.reload();
  }
}

function clearStorage(keepCancellationData = false) {
  let itemsToDelete = [
    "appointmentId",
    "bookingTime",
    "completedStep",
    "desiredDate",
    "desiredTime",
    "info-bookingTime",
    "info-client_number",
    "info-productServiceName",
    "info-serviceName",
    "location",
    "new_client_email",
    "new_client_first_name",
    "new_client_last_name",
    "new_client_number",
    "new_client_temp_access",
    "Note",
    "provider",
    "serviceId",
    "step",
    "takenSlots",
    "temp-shopify-create-account",
  ];

  if (!keepCancellationData) {
    itemsToDelete.concat([
      "clientId",
      "clientPhone",
      "appointmentServiceId",
      "concurrencyCheckDigits",
      "originalProvider",
      "originalSlots",
    ]);
  }

  itemsToDelete.forEach((key) => localStorage.removeItem(key));
}

document.addEventListener("DOMContentLoaded", () => {
  if (checkAuthAndRedirect()) return;

  redirectToFirstStepIfAppointmentDateIsInThePast();

  document.addEventListener("change", (e) => {
    if (e.target.name === "service") {
      document
        .querySelectorAll(".booking-service_label_text_container.selected")
        .forEach((el) => el.classList.remove("selected"));

      if (e.target.classList.contains("booking-service_input_multi")) {
        const parentLabel = e.target.closest(".booking-service_label");
        if (parentLabel) {
          const container = parentLabel.querySelector(
            ".booking-service_label_text_container"
          );
          if (container) {
            container.classList.add("selected");
          }
        }
      }
    }
    // Validate and update next button state on any input change
    updateNextButtonState();

    const nextButtons = document.querySelectorAll('[data-step="next"]');

    nextButtons.forEach((button) => {
      button.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    });
  });

  // Also listen to input events for real-time validation
  document.addEventListener("input", (e) => {
    updateNextButtonState();
  });

  watchAndStoreFormInputs();
  populateConfirmInfoSection();
  loadConfirmInfoFromNewUser();
  initBooking();
  // Initial state
  updateNextButtonState();
});

// Prevent clicking next if disabled
// Use event delegation for all .btn--next

document.addEventListener("click", (e) => {
  const nextBtn = e.target.closest(".btn--next");
  if (nextBtn && nextBtn.classList.contains("disabled")) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }
  // If it's a next button and not disabled, immediately add .disabled to prevent double clicks
  if (nextBtn && !nextBtn.classList.contains("disabled")) {
    nextBtn.classList.add("disabled");
  }
  // ... existing code ...
});

// Helper to update .btn--next disabled state
function updateNextButtonState() {
  document.querySelectorAll(".btn--next[data-step='next']").forEach((btn) => {
    // Only show/hide for visible step
    const stepSection = btn.closest(
      "section, .booking-section, .booking-nav-buttons"
    );
    // If not visible, skip
    if (
      stepSection &&
      stepSection.classList &&
      stepSection.classList.contains("booking_hidden")
    )
      return;
    // Determine if should be enabled
    const valid = validateStep();
    if (valid) {
      btn.classList.remove("disabled");
    } else {
      btn.classList.add("disabled");
    }
  });
}

// Call updateNextButtonState after step changes
// const originalSetStep = setStep;
// setStep = function (stepNumber) {
//   originalSetStep(stepNumber);
//   updateNextButtonState();
// };

// Message control objects for searching and no timeslots
function messageSearching() {
  const timeslotContainer = document.getElementById(
    "booking_timeslot_container"
  );
  const searchingMessage = document.getElementById(
    "booking_label_message_searching"
  );
  const noTimeslotsMessage = document.getElementById(
    "booking_label_message_no_timeslots"
  );
  return {
    show: function () {
      // if there are timeslots, don't show the searching message
      if (timeslotContainer.children.length) return;
      // otherwise show the searching message
      searchingMessage.classList.remove("booking_label_hidden");
      // if there are no timeslots, don't show the no timeslots message
      if (noTimeslotsMessage)
        noTimeslotsMessage.classList.add("booking_label_hidden");
    },
    hide: function () {
      if (searchingMessage)
        searchingMessage.classList.add("booking_label_hidden");
    },
  };
}
function messageNoTimeslots() {
  const searchingMessage = document.getElementById(
    "booking_label_message_searching"
  );
  const noTimeslotsMessage = document.getElementById(
    "booking_label_message_no_timeslots"
  );
  return {
    show: function () {
      if (noTimeslotsMessage)
        noTimeslotsMessage.classList.remove("booking_label_hidden");
      if (searchingMessage)
        searchingMessage.classList.add("booking_label_hidden");
    },
    hide: function () {
      if (noTimeslotsMessage)
        noTimeslotsMessage.classList.add("booking_label_hidden");
    },
  };
}

// Helper to fetch all employee openings for a date and show/hide messages correctly
function fetchAllOpeningsForEmployees(employees, selectedDate) {
  const selectedServiceId = window.localStorage.getItem("serviceId");

  if (
    !selectedServiceId ||
    selectedServiceId === "undefined" ||
    typeof selectedServiceId === "undefined"
  ) {
    console.error("Can't fetch openings without service ID");

    return;
  }

  let foundTimeslots = false;
  let completed = 0;
  messageSearching().show();
  messageNoTimeslots().hide();

  employees.forEach((employee, employeeIndex) => {
    fetchAsync(
      `https://cleavage-clinic.uc.r.appspot.com/appointments/openings?employeeId=${employee.id}&serviceId=${selectedServiceId}&endDate=${selectedDate}&startDate=${selectedDate}`,
      "POST"
    )
      .then((data) => {
        const simplified = data.flatMap((item) =>
          item.serviceOpenings.map((opening) => ({
            date: opening.date,
            startTime: opening.startTime,
            endTime: opening.endTime,
            resourceId: opening.resourceId,
            resourceName: opening.resourceName,
            serviceName: opening.serviceName,
            employeeName: opening.employeeName,
            employeeId: opening.employeeId,
          }))
        );
        groupServiceOpeningsByDate(employeeIndex, simplified);
        if (simplified.length > 0) {
          foundTimeslots = true;
        }
      })
      .catch((reason) => {
        // handle error if needed
      })
      .finally(() => {
        completed++;
        if (completed === employees.length) {
          messageSearching().hide();
          if (!foundTimeslots) {
            messageNoTimeslots().show();
          }

          updateTimeSlots();
        }
      });
  });
}

function handleModifyButtonClick() {
  // add query param for modify state
  // const urlParams = new URLSearchParams(window.location.search);
  // urlParams.set("modify", "true");
  // window.location.search = urlParams;

  modifyAppointmentDOM();
  // move step to calendar
  setStep(1);
}

function handleCancelButtonClick() {
  if (appointmentCancelled) {
    location.reload();
    return;
  }

  const popup = document.getElementById("cancelAppointmentPopup");
  const isHidden = popup.classList.contains("hidden");
  if (isHidden) {
    popup.classList.remove("hidden");
  } else {
    popup.classList.add("hidden");
  }
}
/**
 * Cancels an appointmetn in meevo
 */
async function cancelAppointment(keepLS) {
  // TO DO need to check within 24 hours, if it is then throw error

  const confirmContent = document.getElementById(
    "cancelAppointmentPopup__confirm"
  );
  const successContent = document.getElementById(
    "cancelAppointmentPopup__success"
  );

  const appointmentServiceId = window.localStorage.getItem(
    "appointmentServiceId"
  );
  const concurrencyCheckDigits = window.localStorage.getItem(
    "concurrencyCheckDigits"
  );

  const bookingData = {
    appointmentServiceId: appointmentServiceId,
    concurrencyCheckDigits: concurrencyCheckDigits,
  };

  try {
    const data = await fetchAsync(
      "https://cleavage-clinic.uc.r.appspot.com/appointments/cancel",
      "DELETE",
      JSON.stringify(bookingData)
    );

    if (data) {
      if (data.error || data.ERROR) {
        console.error("Error from API");

        if (
          typeof data.message !== "undefined" &&
          data.message !== "undefined"
        ) {
          alert(data.message);
        }
      } else {
        // success
        if (!keepLS) {
          appointmentCancelled = true;
          clearStorage();
          confirmContent.classList.add("hidden");
          successContent.classList.remove("hidden");
        }
      }
    }
  } catch (error) {}
}

// Note Handling.
// To do: when step 4 add note
// remove / show button
// when remove button is clicked, send a request to set the note to '' in meevo

/** called when a booking has already been made
 *  Updates titles for modify flow
 *
 */
const modifyAppointmentDOM = () => {
  const titleDateTime = document.getElementById("booking-title__dateTime");
  const titleConfirmation = document.getElementById(
    "booking-title__confirmation"
  );

  titleDateTime.innerHTML = "Reschedule Your Appointment";
  titleConfirmation.innerHTML = "Your Appointment Has Been Rescheduled.";
};

/**
 * Check promo code
 * @param {*} code
 */
const checkPromo = async (code) => {
  try {
    const promoApplied = document.getElementById("promo-applied");
    const promoDiscountMsg = document.getElementById("promo-discount-msg");
    const promoAppliedCode = document.getElementById("applied-code-text");
    const promoForm = document.getElementById("promo-form");
    const promoInput = document.getElementById("promo-code");
    const promoConfirm = document.getElementById("booking-confirmation__promo");
    const promoConfirmText = document.getElementById(
      "booking-confirmation__promo-code"
    );

    const data = await fetchAsync(
      `https://cleavage-clinic.uc.r.appspot.com/promo/${code}`,
      "GET"
    );
    if (data.success === true) {
      promoApplied.classList.remove("hidden");
      promoForm.classList.add("hidden");
      promoConfirm.classList.remove("hidden");
      promoDiscountMsg.innerHTML = data.data.confirmText;
      promoAppliedCode.innerHTML = code.toUpperCase();
      promoConfirmText.innerHTML = code.toUpperCase();
      window.localStorage.setItem(
        "promo",
        `${code.toUpperCase()}: ${data.data.confirmText}`
      );
    } else {
      promoInput.value = "";
      promoInput.placeholder = "Code not found";
      promoInputGroup.classList.add("error");
    }
  } catch (error) {}
};
// Helper to format date as Meevo expects (local time, no Z)
function toMeevoISOString(date) {
  const pad = (n) => String(n).padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    ".0000000"
  );
}

async function handlePaymentInfo() {
  const cardNumber = document.getElementById("card-number");
  const cardExpiry = document.getElementById("card-expiry");
  const cardCvc = document.getElementById("card-cvc");
  const cardName = document.getElementById("card-name");
  const cardAddress = document.getElementById("card-address");
  const cardZip = document.getElementById("card-zip");

  if (
    cardNumber.value &&
    cardExpiry.value &&
    cardCvc.value &&
    cardAddress.value &&
    cardZip.value &&
    cardName.value
  ) {
    console.log("Payment info is valid");
    const paymentData = {
      cardNumber: cardNumber.value,
      cardExpiry: cardExpiry.value,
      cardCvc: cardCvc.value,
      cardName: cardName.value,
      cardAddress: cardAddress.value,
      cardZip: cardZip.value,
    };
    console.log(paymentData);

    const data = await fetchAsync(
      "https://cleavage-clinic.uc.r.appspot.com/appointments/payment",
      "POST",
      JSON.stringify(paymentData)
    );
    console.log(data);
  } else {
    console.log("Payment info is invalid");
  }
}
